import { CommonModule, PlatformLocation } from '@angular/common';
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  ModuleWithProviders,
  NgModule
} from '@angular/core';
import { AppInit } from '@app/helper/AppInit';
import { Constants } from 'src/app/constants';

import { AppDynamicsComponent } from './components/app-dynamics.component';
import { AppDynamicsService } from './services/app-dynamics.service';
import { AppDynamicsSettingsService } from './services/app-dynamics.settings.service';

export function configureAuth(
  platformLocation: PlatformLocation,
  settings: AppDynamicsSettingsService
): () => Promise<any> {
  return () => {
    return AppInit()().then(() => {
      settings.loadConfig({
        appDynamicsKey: Constants.appConfiguration.appDynamicsKey,
        appDynamicsScriptURL: Constants.appConfiguration.appDynamicsScriptURL
      });
    });
  };
}
@NgModule({
  imports: [CommonModule],
  exports: [CommonModule, AppDynamicsComponent],
  declarations: [AppDynamicsComponent],
  providers: [AppDynamicsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppDynamicsModule {
  static forRoot(): ModuleWithProviders<AppDynamicsModule> {
    return {
      ngModule: AppDynamicsModule,
      providers: [
        AppDynamicsSettingsService,
        {
          provide: APP_INITIALIZER,
          useFactory: configureAuth,
          deps: [PlatformLocation, AppDynamicsSettingsService],
          multi: true
        }
      ]
    };
  }
}
